import { type ProjectCode } from '@constants'
import { useApiCampaignProductsList } from '@hooks-api/fortune-fastpass/use-api-campaign-products-list'
import { useMemo } from 'react'
import { fpConvertCampaignProductCatalogDTO } from '../dtos/fpConvertProductCatalogDTO'

export const useFpCampaignProductCatalogProducts = (projectCode: ProjectCode, campaignCode: string | undefined) => {
  const response = useApiCampaignProductsList({
    campaign_code: campaignCode,
    project_code: projectCode,
  }, {
    keepPreviousData: true,
  })

  const productCatalogDto = useMemo(() => response.data?.data ? fpConvertCampaignProductCatalogDTO(response.data.data) : undefined, [response.data])

  return {
    ...response,
    productCatalogDto,
  }
}
